<script lang="ts">
    import type { StringSetting } from "..";

    export let setting: StringSetting;
</script>

<!----------------------------------------------------------------------------->

<input id={setting.id} type="text" bind:value={setting.value} />

<!----------------------------------------------------------------------------->

<style>
    input {
        width: 20ch;
    }
</style>
